/**
 * Context de Toast
 * Gerencia notificações toast globalmente na aplicação
 */

import React, { createContext, useContext } from "react";
import useToast from "../hooks/useToast";
import { ToastContainer } from "../components/ui/Toast";
import { ToastNotificationContainer } from "../components/ui/ToastNotification";

const ToastContext = createContext(null);

/**
 * Provider de Toast
 */
export const ToastProvider = ({ children }) => {
  const toast = useToast();

  return (
    <ToastContext.Provider value={toast}>
      {children}
      {/* Toast customizado visível */}
      <ToastNotificationContainer toasts={toast.toasts} onClose={toast.removeToast} />
      {/* Toast do Ant Design (backup) */}
      <ToastContainer toasts={toast.toasts} onClose={toast.removeToast} />
    </ToastContext.Provider>
  );
};

/**
 * Hook para usar o contexto de Toast
 */
export const useToastContext = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToastContext deve ser usado dentro de ToastProvider");
  }
  return context;
};

export default ToastContext;
